import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from "react-redux";
import PicButton from "../../../../../../../../../../components/pic-button/index";
import Icon from "../../../../../../../../../../components/icon/index";
import T2 from "./components/t2/index";
import {deleteContact, putLabelToRemove} from "../../../../../../../../../../../actions/contactActions";
import {getSharingDetailsPopup} from "../../../../../../../../../../../actions/sharingDetailsActions";
import {labelStateUpdating} from "../../../../../../../../../../../actions/contactsGroupItemActions";
import {guidedTours} from "../../../../../../../../../../../actions/guidedToursActions";
import './index.css';

class BulkContactsActions extends Component {

    constructor(props){
        super(props);
        this.addToLabelHandler = this.addToLabelHandler.bind(this);
        this.emailHandler = this.emailHandler.bind(this);
        this.shareContactHandler = this.shareContactHandler.bind(this);
        this.removeLabelAttachmentHandler = this.removeLabelAttachmentHandler.bind(this);
        this.deleteContactHandler = this.deleteContactHandler.bind(this);
    }

    addToLabelHandler(){
        this.props.getSharingDetailsPopup([true, "select_one_label", this.props.selectedContacts, false, false, 'fromAddToLabelButton']);
    }

    emailHandler(){

        let getEmails = [];

        this.props.selectedContacts.forEach((selectedContact) => {

            if (selectedContact.email.length > 0) {
                getEmails = getEmails.concat(selectedContact.email)
            }

        });

        window.open("mailto:" + getEmails.join(";"), "_blank");

    }

    shareContactHandler(){
        if(this.props.findLabels.contactsGroups.length > 0 ) {
            this.props.getSharingDetailsPopup([true, "select_one_label", this.props.selectedContacts]);
        } else {
            this.props.getSharingDetailsPopup([true, "add_user", "first_time"]);

            if(document.getElementById('t2') && this.props.guidedTours.t2 === false){
                document.getElementById('t2').style.transform = 'scale(0)';

                setTimeout(() => {
                    this.props.setGuidedTours({
                        't1': true,
                        't2': true
                    });
                }, 250)
            }

        }
    }

    removeLabelAttachmentHandler(){
        this.props.labelStateUpdating(this.props.selectedContactsGroup.id);
        this.props.putLabelToRemove(this.props.selectedContacts, [this.props.selectedContactsGroup.id])
    }

    deleteContactHandler(){
	    this.props.getSharingDetailsPopup([true, 'delete_contact', this.props.selectedContacts])
        //this.props.deleteContact(this.props.selectedContacts, this.props.selectedContactsGroup.id);
    }

    render() {
        return (
            <React.Fragment>
                {
                    this.props.selectedContacts.length > 0
                        ?
                        <div className="d-flex align-items-center contacts-bulk-action ml-2 pl-3 border-left h-100 text-nowrap">
                            {this.props.selectedContacts.length}&nbsp;
	                        { this.props.selectedContacts.length > 1 ? this.props.t('contactsSelected') : this.props.t('contactSelected') }
                            <div className="d-flex align-items-center ml-3 pl-2 border-left h-100">
                                {
                                    this.props.findLabels.contactsGroups.length > 0
                                    && ( this.props.selectedContactsGroup.permission === "OWNER"
                                    || this.props.selectedContactsGroup.permission === "CAN_SHARE"
                                    || this.props.selectedContactsGroup.permission === "WRITE_DELETE"
                                    || this.props.selectedContactsGroup.permission === "WRITE_ONLY")
                                        ?
                                        <PicButton onClick={this.emailHandler} className="d-flex align-items-center">
                                            <svg
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                            >
                                                <path fill="currentColor" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.8 2L12 10.8 4.8 6h14.4zM4 18V7.87l8 5.33 8-5.33V18H4z" />
                                            </svg>
                                        </PicButton>
                                        :
                                        <PicButton disabled={true} className="d-flex align-items-center">
                                            <svg
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                            >
                                                <path fill="currentColor" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.8 2L12 10.8 4.8 6h14.4zM4 18V7.87l8 5.33 8-5.33V18H4z" />
                                            </svg>
                                        </PicButton>
                                }
                                {
                                    this.props.findLabels.contactsGroups.length > 0
                                    && ( this.props.selectedContactsGroup.permission === "OWNER"
                                    || this.props.selectedContactsGroup.permission === "CAN_SHARE"
                                    || this.props.selectedContactsGroup.permission === "WRITE_DELETE"
                                    || this.props.selectedContactsGroup.permission === "WRITE_ONLY")
                                        ?
                                        <PicButton onClick={this.addToLabelHandler} className="d-flex align-items-center">
                                            <svg width="24" height="24" viewBox="0 0 24 24">
                                                <path fill="none" d="M0 0h24v24H0V0z"/>
                                                <path
                                                    fill="currentColor"
                                                    d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"/>
                                            </svg>
                                        </PicButton>
                                        :
                                        <PicButton disabled={true} className="d-flex align-items-center">
                                            <svg width="24" height="24" viewBox="0 0 24 24">
                                                <path fill="none" d="M0 0h24v24H0V0z"/>
                                                <path
                                                    fill="currentColor"
                                                    d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"/>
                                            </svg>
                                        </PicButton>
                                }
                                {
                                    (this.props.findLabels.contactsGroups.length > 0 || this.props.selectedContactsGroup.id==='6')
                                    && ( this.props.selectedContactsGroup.permission === "OWNER"
                                    || this.props.selectedContactsGroup.permission === "CAN_SHARE" )
                                        ?
                                        <PicButton onClick={this.shareContactHandler} id="shareContacts" className="d-flex align-items-center" title={this.props.t("shareContacts")}>
                                            <svg width="16px" height="16px" viewBox="0 0 16 16">
                                                <line fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" x1="5.425" y1="9.046" x2="10.575" y2="11.62"/>
                                                <line fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" x1="5.425" y1="6.954" x2="10.575" y2="4.379"/>
                                                <path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M15,3.334c0,1.287-1.046,2.332-2.333,2.332
                                                    s-2.334-1.045-2.334-2.332C10.333,2.046,11.38,1,12.667,1S15,2.046,15,3.334"/>
                                                <path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M15,12.667C15,13.954,13.954,15,12.667,15
                                                    s-2.334-1.046-2.334-2.333s1.047-2.334,2.334-2.334S15,11.38,15,12.667"/>
                                                <path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M5.666,8c0,1.287-1.045,2.333-2.332,2.333
                                                    C2.046,10.333,1,9.287,1,8s1.046-2.334,2.334-2.334C4.62,5.666,5.666,6.713,5.666,8"/>
                                            </svg>
                                        </PicButton>
                                        :
                                        <PicButton disabled={true} id="shareContacts" className="d-flex align-items-center">
                                            <svg width="16px" height="16px" viewBox="0 0 16 16">
                                                <line fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" x1="5.425" y1="9.046" x2="10.575" y2="11.62"/>
                                                <line fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" x1="5.425" y1="6.954" x2="10.575" y2="4.379"/>
                                                <path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M15,3.334c0,1.287-1.046,2.332-2.333,2.332
                                                    s-2.334-1.045-2.334-2.332C10.333,2.046,11.38,1,12.667,1S15,2.046,15,3.334"/>
                                                <path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M15,12.667C15,13.954,13.954,15,12.667,15
                                                    s-2.334-1.046-2.334-2.333s1.047-2.334,2.334-2.334S15,11.38,15,12.667"/>
                                                <path fill="none" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" d="M5.666,8c0,1.287-1.045,2.333-2.332,2.333
                                                    C2.046,10.333,1,9.287,1,8s1.046-2.334,2.334-2.334C4.62,5.666,5.666,6.713,5.666,8"/>
                                            </svg>
                                        </PicButton>
                                }
                                {
                                    this.props.selectedContactsGroup.id !== "6"
                                    ?
                                        this.props.selectedContactsGroup.permission === "OWNER"
                                        || this.props.selectedContactsGroup.permission === "CAN_SHARE"
                                        || this.props.selectedContactsGroup.permission === "WRITE_DELETE"
                                        ?
                                            <PicButton onClick={this.removeLabelAttachmentHandler}>
                                                <Icon name="chain-broken"/>
                                            </PicButton>
                                        :
                                            <PicButton disabled={true}>
                                                <Icon name="chain-broken"/>
                                            </PicButton>
                                    :
                                        null
                                }
                                {
                                    this.props.selectedContactsGroup.permission === "OWNER"
                                    || this.props.selectedContactsGroup.permission === "CAN_SHARE"
                                    || this.props.selectedContactsGroup.permission === "WRITE_DELETE"
                                    ?
                                        <PicButton onClick={this.deleteContactHandler}>
                                            <Icon name="trash"/>
                                        </PicButton>
                                    :
                                        <PicButton disabled={true}>
                                            <Icon name="trash"/>
                                        </PicButton>
                                }
                            </div>
                            {
                                this.props.guidedTours
                                    ?
                                    this.props.guidedTours.t2 === false && this.props.findLabels && this.props.findLabels.contactsGroups.length === 0
                                        ?
                                        <T2/>
                                        :
                                        null
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        findLabels: state.contactsGroupItemReducer.findLabels,
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        selectedContacts: state.contactReducer.selectedContacts,
        guidedTours: state.guidedToursReducer.guidedTours,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        putLabelToRemove : (contactIds, labelTargetId) => {
            dispatch(putLabelToRemove(contactIds, labelTargetId))
        },
        deleteContact : (contactIds, labelId) => {
            dispatch(deleteContact(contactIds, labelId))
        },
        labelStateUpdating : (labelId) => {
            dispatch(labelStateUpdating(labelId))
        },
        setGuidedTours: (object) => {
            dispatch(guidedTours(object));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BulkContactsActions));
